import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { userRoleLabels } from 'utils/enums/user-roles.enum';
import layoutNames from 'utils/enums/layout-names.enum';

//ecm imports
import AuthService from 'services/auth.service';
import { setPageHeaderTextActionCreator } from 'plugins/store/reducers/common.reducer';
import styles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles';

// @material-ui/icons
import PermIdentity from '@material-ui/icons/PermIdentity';
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import ReadOnlyField from 'components/ReadOnlyField/ReadOnlyField';
import Button from 'components/CustomButtons/Button';

const localStyles = {
	header: {
		position: 'absolute',
		top: '-2rem',
		left: 0,
		padding: '0 20px',
		zIndex: 20,
	},
	permissionsLabel: {
		fontSize: '18px',
		color: '#808080',
		lineHeight: '21px',
		fontWeight: '300',
	},
};

class UserProfilePage extends Component {
	state = {
		user: undefined,
	};

	componentDidMount() {
		const user = AuthService.getCurrentUser();
		this.setState({
			user,
		});
		this.props.setPageHeaderText('Profile');
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
	}

	toChangePasswordPage = () => {
		this.props.history.push(`/${layoutNames.auth}/change-password`);
	}

	render() {
		const user = this.state.user;
		const userRoleName = userRoleLabels[user?.role];

		return (
			<div>
				<GridContainer>
					<GridItem xs={12} sm={12} md={12}>
						<Card>
							<CardHeader color="rose" icon>
								<CardIcon color="rose">
									<PermIdentity />
								</CardIcon>
							</CardHeader>
							<CardBody>
								<GridContainer
									className={this.props.classes.header}
									container
									direction="row"
									justify="flex-end"
									alignItems="center"
								>
									<GridItem>
										<Button
											color="transparent"
											aria-haspopup="true"
											size='sm'
											onClick={this.toChangePasswordPage}
										>
											Change Password
										</Button>
									</GridItem>
								</GridContainer>

								<GridContainer>
									<GridItem xs={12} sm={12} md={5}>
										<ReadOnlyField
											label="Username"
											value={user?.username || ''}
										/>
										<ReadOnlyField
											label="Full Name"
											value={`${user?.firstName || ''} ${
												user?.lastName || ''
											}`}
										/>
										<ReadOnlyField
											label="Email"
											value={user?.email || ''}
										/>
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	setPageHeaderText: bindActionCreators(
		setPageHeaderTextActionCreator,
		dispatch
	),
});

export default withRouter(withStyles({ ...localStyles, ...styles })(
	connect(mapStateToProps, mapDispatchToProps)(UserProfilePage)
));
